import * as React from 'react';
import { IconButton, Skins } from 'wix-ui-tpa/IconButton';
import { ShareIcon } from '../../icons/ShareIcon';
import styles from './ShareButton.st.css';

export interface ShareButtonProps {
  onClick();
}

export const ShareButton: React.FC<ShareButtonProps> = ({
  onClick,
  ...restProps
}) => {
  return (
    <IconButton
      data-hook="share-button"
      skin={Skins.Full}
      icon={<ShareIcon width="24px" height="24px" />}
      onClick={onClick}
      {...styles(styles.root, {}, restProps)}
    />
  );
};
